// Import styles
import "./application.css"

// Import and initialize Turbo
import "@hotwired/turbo-rails"

// Keep Turbo's history restoration state intact when TanStack Router (SPA
// sections) rewrites history.state, so browser Back restores those pages.
import { preserveTurboHistoryState } from "../react/router/preserveTurboHistoryState"
preserveTurboHistoryState()

// Import core dependencies
import { registerControllers } from "stimulus-vite-helpers"

// Import the shared Stimulus application instance
import { application } from '../controllers/application'
import { handleVitePreloadError } from '~/utils/vite_preload_recovery'

// Initialize React component registry
// This registers all React components for use with the react-component Stimulus controller
import '../react'

// Configure debugging in development
if (import.meta.env.MODE === "development") {
  application.debug = true
}

// Register all Stimulus controllers BEFORE starting the application
const controllers = import.meta.glob("../controllers/**/*_controller.js", { eager: true })
registerControllers(application, controllers)

// Start the Stimulus application AFTER registering controllers
application.start()

// Recover from a stale-deploy chunk 404 (see vite_preload_recovery.js)
window.addEventListener('vite:preloadError', handleVitePreloadError)
